import { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { Chart as ChartJS, Title, Legend, ArcElement } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { getBaseDoughnutChartOptions, beforeDrawHandler } from './utlizationChart';

ChartJS.register(Title, Legend, ArcElement, ChartDataLabels, {
    id: 'centerTextPlugin',
    beforeDraw: beforeDrawHandler
});

// A single, colorless-legend doughnut ring for a product, shared by the utilization
// charts that don't need per-segment click/hover behavior (PdfActionsByProductChart,
// PdfGenerationsByMessageTypeChart, QuicksheetsByActionTypeChart). Declared at module
// scope, rather than inside those parent components, so it keeps a stable component
// identity across parent re-renders instead of being redefined - and remounted - on
// every render.
const SimpleDoughnutChart = forwardRef(({ productData, columnSize, appState }, chartRef) => {
    const chartData = {
        labels: productData.chartData.labels,
        datasets: productData.chartData.dataSets
    };

    const baseDoughnutChartOptions = getBaseDoughnutChartOptions(appState);
    const doughnutChartOptions = {
        type: 'doughnut',
        responsive: true,
        maintainAspectRatio: false,
        resizeDelay: 200,
        layout: baseDoughnutChartOptions.layout,
        plugins: {
            datalabels: baseDoughnutChartOptions.datalabels,
            legend: baseDoughnutChartOptions.legend,
            tooltip: baseDoughnutChartOptions.tooltip,
            title: baseDoughnutChartOptions.title,
            centerTextPlugin: {
                text: productData.name
            }
        }
    };

    return (
        <div className={`col-${columnSize} chart-canvas-wrapper mb-5`}>
            <Doughnut ref={chartRef} options={doughnutChartOptions} data={chartData} />
        </div>
    );
});

SimpleDoughnutChart.displayName = 'SimpleDoughnutChart';

SimpleDoughnutChart.propTypes = {
    productData: PropTypes.shape({
        name: PropTypes.string,
        chartData: PropTypes.shape({
            labels: PropTypes.arrayOf(PropTypes.string),
            dataSets: PropTypes.arrayOf(PropTypes.object)
        })
    }).isRequired,
    columnSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    appState: PropTypes.object
};

export default SimpleDoughnutChart;
